export const InboxSize = 5;
